import { IReflist } from '../api/models/reflist/reflist.types';

export interface IReflists {
  me: IReflist;
}

export enum EReflistSubject {
  ME = 'entriesMe',
  OTHER = 'entriesOther',
}

export enum EReflistEditSection {
  MY_INFORMATIONS = 'myInformations',
  MAIN_INFORMATIONS = 'mainInformations',
  COMPLEMENTARY_INFORMATIONS = 'complementaryInformations',
  HOBBIES = 'hobbies',
  VISION = 'vision',
  TASTES = 'tastes',
  YEARNINGS = 'yearnings',
}
